export default __webpack_public_path__ + "static/media/regulatory--length-limit--g2.8ef7d18d.png";